import Vue from 'vue';
import Vuex from 'vuex';
import makeCrudModule from './modules/crud';
import notifications from './modules/notifications';

//profile
import accessoryService from '../services/accessory';
import optionService from '../services/option';
import controlunitService from '../services/controlunit';
import industrialcomputerService from '../services/industrialcomputer';
import operatingsystemService from '../services/operatingsystem';
import machineService from '../services/machine';
import machinemodelService from '../services/machinemodel';
import materialService from '../services/material';
import materialcolorService from '../services/materialcolor';
import materialfeedspecService from '../services/materialfeedspec';
import materialmanufacturerService from '../services/materialmanufacturer';
import materialmediumService from '../services/materialmedium';
import materialstateService from '../services/materialstate';
import materialsupplyService from '../services/materialsupply';
import materialsupplysubService from '../services/materialsupplysub';
import materialtypeService from '../services/materialtype';
import nozzleService from '../services/nozzle';
import nozzleinService from '../services/nozzlein';
import nozzlemanufacturerService from '../services/nozzlemanufacturer';
import nozzlematerialService from '../services/nozzlematerial';
import nozzleoutService from '../services/nozzleout';
import nozzletypeService from '../services/nozzletype';
import nozzlevisualService from '../services/nozzlevisual';
import printingsurfaceService from '../services/printingsurface';
import printingsurfacematerialService from '../services/printingsurfacematerial';
import printingsurfacesizeService from '../services/printingsurfacesize';
import printingsurfacethicknessService from '../services/printingsurfacethickness';
import profilebenchmarkService from '../services/profilebenchmark';
import profileparameterService from '../services/profileparameter';
import profileparametersetService from '../services/profileparameterset';
import profileparametersetvalueService from '../services/profileparametersetvalue';
import profilestrategyService from '../services/profilestrategy';
import profilestrategyqualityService from '../services/profilestrategyquality';
import profiletoolService from '../services/profiletool';
import qualityService from '../services/quality';
import qualityfocusService from '../services/qualityfocus';
import qualitylayerService from '../services/qualitylayer';
import scoreService from '../services/score';
import sectionparameterService from '../services/sectionparameter';
import setupdefinitionService from '../services/setupdefinition';
import setupdefinitionsubService from '../services/setupdefinitionsub';
import softwareService from '../services/software';
import softwareversionService from '../services/softwareversion';
import toolService from '../services/tool';
import toolextruderService from '../services/toolextruder';
import toolheadService from '../services/toolhead';
import toolheadsubService from '../services/toolheadsub';
import toolheaterService from '../services/toolheater';
import hardnessshoretypeService from '../services/hardnessshoretype';
import producttypefiletypeService from '../services/producttypefiletype';
import producttypefileService from '../services/producttypefile';
import profilefileService from '../services/profilefile';
import articleService from '../services/article';
import designfiletypeService from '../services/designfiletype';
import designfileService from '../services/designfile';

import materialproductService from '../services/materialproduct';
import materialproductversionService from '../services/materialproductversion';
import materialproductlotService from '../services/materialproductlot';
//process
import processschemaService from '../services/processschema';
import serviceService from '../services/service';
import macrotypeService from '../services/macrotype';
import processtypeService from '../services/processtype';
import processService from '../services/process';
import stepService from '../services/step';
import stepfieldService from '../services/stepfield';
import categoryService from '../services/category';
import exportprocessService from '../services/exportprocess';
//version
import linkService from '../services/link';
import changelogService from '../services/changelog';
//quality check
import contactService from '../services/contact';
import customerService from '../services/customer';
import distributorService from '../services/distributor';
import customertagService from '../services/customertag';
import productService from '../services/product';
import productdataService from '../services/productdata';
import productstatusService from '../services/productstatus';
import qualitycheckService from '../services/qualitycheck';
import qualitychecktestService from '../services/qualitychecktest';
import qualitycheckvalueService from '../services/qualitycheckvalue';
import qualitycheckvaluetypeService from '../services/qualitycheckvaluetype';
//ticket
import bugtypeService from '../services/bugtype';
import priorityService from '../services/priority';
import actiontypeService from '../services/actiontype';
import ticketstatusService from '../services/ticketstatus';
import ticketoriginService from '../services/ticketorigin';
import ticketactionService from '../services/ticketaction';
import ticketService from '../services/ticket';
import tagService from '../services/tag';
import contractService from '../services/contract';
import contracttypeService from '../services/contracttype';
//user
import userService from '../services/user';
import forgotpasswordService from '../services/forgotpassword';
import connexionuserService from '../services/connexionuser';
import mediaobjectService from '../services/mediaobject';
import profilService from '../services/profil';
import profilinterfaceService from '../services/profilinterface';
import accessService from '../services/accesses';
import notificationService from '../services/notification';
import securityparameterService from '../services/securityparameter';
import gifService from '../services/gif';
import badgeService from '../services/badge';
import applicationService from '../services/application';
import notificationuserService from '../services/notificationuser';
import notificationtypeService from '../services/notificationtype';
import backupService from '../services/backup';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    notifications,
    accessory: makeCrudModule({
      service: accessoryService
    }),
    option: makeCrudModule({
      service: optionService
    }),
    controlunit: makeCrudModule({
      service: controlunitService
    }),
    industrialcomputer: makeCrudModule({
      service: industrialcomputerService
    }),
    operatingsystem: makeCrudModule({
      service: operatingsystemService
    }),
    machine: makeCrudModule({
      service: machineService
    }),
    machinemodel: makeCrudModule({
      service: machinemodelService
    }),
    material: makeCrudModule({
      service: materialService
    }),
    materialcolor: makeCrudModule({
      service: materialcolorService
    }),
    materialfeedspec: makeCrudModule({
      service: materialfeedspecService
    }),
    materialmanufacturer: makeCrudModule({
      service: materialmanufacturerService
    }),
    materialmedium: makeCrudModule({
      service: materialmediumService
    }),
    materialstate: makeCrudModule({
      service: materialstateService
    }),
    materialsupply: makeCrudModule({
      service: materialsupplyService
    }),
    materialsupplysub: makeCrudModule({
      service: materialsupplysubService
    }),
    materialtype: makeCrudModule({
      service: materialtypeService
    }),
    nozzle: makeCrudModule({
      service: nozzleService
    }),
    nozzlein: makeCrudModule({
      service: nozzleinService
    }),
    nozzlemanufacturer: makeCrudModule({
      service: nozzlemanufacturerService
    }),
    nozzlematerial: makeCrudModule({
      service: nozzlematerialService
    }),
    nozzleout: makeCrudModule({
      service: nozzleoutService
    }),
    nozzletype: makeCrudModule({
      service: nozzletypeService
    }),
    nozzlevisual: makeCrudModule({
      service: nozzlevisualService
    }),
    printingsurface: makeCrudModule({
      service: printingsurfaceService
    }),
    printingsurfacematerial: makeCrudModule({
      service: printingsurfacematerialService
    }),
    printingsurfacesize: makeCrudModule({
      service: printingsurfacesizeService
    }),
    printingsurfacethickness: makeCrudModule({
      service: printingsurfacethicknessService
    }),
    profilebenchmark: makeCrudModule({
      service: profilebenchmarkService
    }),
    profileparameter: makeCrudModule({
      service: profileparameterService
    }),
    profileparameterset: makeCrudModule({
      service: profileparametersetService
    }),
    profileparametersetvalue: makeCrudModule({
      service: profileparametersetvalueService
    }),
    profilestrategy: makeCrudModule({
      service: profilestrategyService
    }),
    profilestrategyquality: makeCrudModule({
      service: profilestrategyqualityService
    }),
    profiletool: makeCrudModule({
      service: profiletoolService
    }),
    quality: makeCrudModule({
      service: qualityService
    }),
    qualityfocus: makeCrudModule({
      service: qualityfocusService
    }),
    qualitylayer: makeCrudModule({
      service: qualitylayerService
    }),
    score: makeCrudModule({
      service: scoreService
    }),
    sectionparameter: makeCrudModule({
      service: sectionparameterService
    }),
    setupdefinition: makeCrudModule({
      service: setupdefinitionService
    }),
    setupdefinitionsub: makeCrudModule({
      service: setupdefinitionsubService
    }),
    software: makeCrudModule({
      service: softwareService
    }),
    softwareversion: makeCrudModule({
      service: softwareversionService
    }),
    tool: makeCrudModule({
      service: toolService
    }),
    toolextruder: makeCrudModule({
      service: toolextruderService
    }),
    toolhead: makeCrudModule({
      service: toolheadService
    }),
    toolheadsub: makeCrudModule({
      service: toolheadsubService
    }),
    toolheater: makeCrudModule({
      service: toolheaterService
    }),
    link: makeCrudModule({
      service: linkService
    }),
    changelog: makeCrudModule({
      service: changelogService
    }),
    contact: makeCrudModule({
      service: contactService
    }),
    contract: makeCrudModule({
      service: contractService
    }),
    contracttype: makeCrudModule({
      service: contracttypeService
    }),
    customer: makeCrudModule({
      service: customerService
    }),
    customertag: makeCrudModule({
      service: customertagService
    }),
    distributor: makeCrudModule({
      service: distributorService
    }),
    product: makeCrudModule({
      service: productService
    }),
    productdata: makeCrudModule({
      service: productdataService
    }),
    productstatus: makeCrudModule({
      service: productstatusService
    }),
    qualitycheck: makeCrudModule({
      service: qualitycheckService
    }),
    qualitychecktest: makeCrudModule({
      service: qualitychecktestService
    }),
    qualitycheckvalue: makeCrudModule({
      service: qualitycheckvalueService
    }),
    qualitycheckvaluetype: makeCrudModule({
      service: qualitycheckvaluetypeService
    }),
    user: makeCrudModule({
      service: userService
    }),
    forgotpassword: makeCrudModule({
      service: forgotpasswordService
    }),
    connexionuser: makeCrudModule({
      service: connexionuserService
    }),
    mediaobject: makeCrudModule({
      service: mediaobjectService
    }),
    profil: makeCrudModule({
      service: profilService
    }),
    profilinterface: makeCrudModule({
      service: profilinterfaceService
    }),
    accesses: makeCrudModule({
      service: accessService
    }),
    notificationuser: makeCrudModule({
      service: notificationService
    }),
    securityparameter: makeCrudModule({
      service: securityparameterService
    }),
    gif: makeCrudModule({
      service: gifService
    }),
    badge: makeCrudModule({
      service: badgeService
    }),
    bugtype: makeCrudModule({
      service: bugtypeService
    }),
    actiontype: makeCrudModule({
      service: actiontypeService
    }),
    ticketstatus: makeCrudModule({
      service: ticketstatusService
    }),
    ticketorigin: makeCrudModule({
      service: ticketoriginService
    }),
    ticketaction: makeCrudModule({
      service: ticketactionService
    }),
    tag: makeCrudModule({
      service: tagService
    }),
    ticket: makeCrudModule({
      service: ticketService
    }),
    notificationtype: makeCrudModule({
      service: notificationtypeService
    }),
    notificationusersubscriber: makeCrudModule({
      service: notificationuserService
    }),
    hardnessshoretype: makeCrudModule({
      service: hardnessshoretypeService
    }),
    application: makeCrudModule({
      service: applicationService
    }),
    priority: makeCrudModule({
      service: priorityService
    }),
    backup: makeCrudModule({
      service: backupService
    }),
    producttypefiletype: makeCrudModule({
      service: producttypefiletypeService
    }),
    producttypefile: makeCrudModule({
      service: producttypefileService
    }),
    profilefile: makeCrudModule({
      service: profilefileService
    }),
    processschema: makeCrudModule({
      service: processschemaService
    }),
    service: makeCrudModule({
      service: serviceService
    }),
    macrotype: makeCrudModule({
      service: macrotypeService
    }),
    processtype: makeCrudModule({
      service: processtypeService
    }),
    process: makeCrudModule({
      service: processService
    }),
    step: makeCrudModule({
      service: stepService
    }),
    stepfield: makeCrudModule({
      service: stepfieldService
    }),
    materialproduct: makeCrudModule({
      service: materialproductService
    }),
    materialproductversion: makeCrudModule({
      service: materialproductversionService
    }),
    materialproductlot: makeCrudModule({
      service: materialproductlotService
    }),
    article: makeCrudModule({
      service: articleService
    }),
    designfile: makeCrudModule({
      service: designfileService
    }),
    designfiletype: makeCrudModule({
      service: designfiletypeService
    }),
    category: makeCrudModule({
      service: categoryService
    }),
    exportprocess: makeCrudModule({
      service: exportprocessService
    }),
  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
